export const feedbackStyles = theme => ({
    feedbackContainer: {
        height: 'calc(100%  - 40px)',
        fontSize: '14px',
        backgroundColor: theme.palette.background,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        padding: '20px 30px',
        lineHeight: '2.14'
    },
    starEmpty: {
        color: theme.palette.red
    },
    starFocus: {
        color: theme.palette.red
    },
    dialogContent: {
        paddingLeft: '8px !important',
        paddingRight: '8px !important',
    },
    heading: {
        fontSize: '15px',
        fontWeight: '500'
    },
    subHeading: {
        fontSize: '13px',
        padding: '1vh',
        margin: '1vh'
    },
    root: {
        background: theme.palette.paleGray2
    },
    star: {
        color: 'black'
    },
    centerAlign: {
        textAlign: 'center'
    },
    feedbackInfo: {
        textAlign: 'center',
        fontSize: '14px',
        margin: '1vh 0vw',
        color: theme.palette.black,
        fontWeight:'500',
        lineHeight: '1.2'
    },
    feedbackText:{
        fontSize: '13px',
        textAlign: 'center'
    },
    button: {
        marginTop: '1vh',
        marginBottom: '1vh',
        marginRight: '2vw',
        background: theme.palette.red,
        fontSize: '13px',
        width: '100px',
        color: theme.palette.white,
        borderRadius: '10px',
        '&:hover': {
            backgroundColor: theme.palette.red,
        }
    },
    cancelButton: {
        marginTop: '1vh',
        marginBottom: '1vh',
        background: '#838383',
        fontSize: '14.5px',
        width: '100px',
        borderRadius: '10px',
        color: theme.palette.white,
        marginRight: '1vw',
        '&:hover': {
            backgroundColor: `${theme.palette.coolGray2} !important`,
        }
    },
    error: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        marginTop: '2VH'
    },
    errorStyle: {
        color: theme.palette.red,
        fontSize: '12px',
        margin: '0vh 5px',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100%'
    },
    dialog: {
        textAlign: 'center',
        backgroundColor: theme.palette.white,
        marginBottom: '2VH',
        width: '70%',
        borderRadius: '10px !important',
        boxShadow: '0 0 18px 0 rgba(0, 0, 0, 0.2)'
    }
});